'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.allMessages = undefined;

var _en = require('translations/en');

var _en2 = _interopRequireDefault(_en);

var _de = require('translations/de');

var _de2 = _interopRequireDefault(_de);

var _fr = require('translations/fr');

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allMessages = exports.allMessages = {
    en: _en2.default,
    de: _de2.default,
    fr: _fr2.default
};


//////////////////
// WEBPACK FOOTER
// ./app/utils/messages.js
// module id = 641
// module chunks = 0